import { memo } from "react";
import { Button } from "react-bootstrap";

import pdfImg from "assets/svg/pdf.svg";

type ReportHeaderProps = {
    organizationName: string;
    isDisableExport: boolean;
    handleExportPDF: () => Promise<void>;
}

export default memo(function ReportHeader({
    organizationName,
    isDisableExport,
    handleExportPDF,
}: Readonly<ReportHeaderProps>) {
    const handleExportPDFClick = () => {
        handleExportPDF().catch((error) => {
            console.error('Failed to export Report PDF', error);
        });
    };

    return (
        <section className="report-header">
            <div className="report-title-container">
                <p className="report-title">Reports</p>
                <p className="report-subtitle">{organizationName}</p>
            </div>
            <Button
                variant="primary"
                className="report-export-btn"
                disabled={isDisableExport}
                onClick={handleExportPDFClick}
            >
                <img src={pdfImg} alt="download" /> Export as PDF
            </Button>
        </section>
    );
});
